import { useQuery } from '@tanstack/react-query';
import { MarketingFiltersQueryKeys } from '@enums/react-query-keys';
import { ContentsMarketingFilter } from '@interfaces/models/contentsMarketingFilter';
import { getMarketingFilters } from '@api/contents';
import { useMemo } from 'react';

const useMarketingFiltersQuery = (enabled = true) => {
  const { data: marketingFilters, refetch } = useQuery<ContentsMarketingFilter[]>({
    queryKey: [MarketingFiltersQueryKeys.MARKETING_FILTERS],
    staleTime: Infinity,
    queryFn: () => getMarketingFilters(),
    enabled,
  });

  const localToLocalFilter = useMemo(
    () => marketingFilters?.find((filter) => filter.filterType === 'sustainability'),
    [marketingFilters],
  );
  const freeShippingFilter = useMemo(
    () => marketingFilters?.find((filter) => filter.filterType === 'freeShipping'),
    [marketingFilters],
  );

  const dealMarketingFilter = useMemo(
    () => marketingFilters?.find((filter) => filter.filterType === 'deal'),
    [marketingFilters],
  );
  return {
    marketingFilters: marketingFilters || [],
    localToLocalFilter,
    freeShippingFilter,
    dealMarketingFilter,
    refetchMarketingFilters: refetch,
  };
};

export default useMarketingFiltersQuery;
